<form [formGroup]="form" (submit)="onSubmit($event)">
  @if (!hasChildAOE) {
    <div class="dynamic-form">
      @for (field of fields; track field) {
        <ng-container appDynamicField [field]="field" [loadFor]="loadFor" [group]="form">
        </ng-container>
      }
    </div>
  }
  @if (hasChildAOE) {
    <div class="dynamic-form" [class.is-inner-page]="innerPage">
      @for (field of fields; track field; let i = $index) {
        <div class="aoe-controls" [style.display]="!field.isChildAoe ? 'block' : 'none'">
          @if (!field.isChildAoe) {
            <ng-template appDynamicField [field]="field" [group]="form">
            </ng-template>
          }
        </div>
      }
    </div>
  }
</form>
